import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const { colors } = constants;
const { fontFamily } = typographyStyles;

export const newselaLogoCss: CSSObject = {
  width: "131px",
  height: "32px",
};

export const lessonPlanContainerCss: CSSObject = {
  ...fontFamily.circular,
  maxWidth: "800px",
  margin: "0 auto",
  padding: 0,
  lineHeight: 1.6,
};

export const headerCss: CSSObject = {
  padding: "20px 30px 10px",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  marginBottom: "25px",
};

export const titleTextCss: CSSObject = {
  margin: 0,
  color: colors.ui.black[500],
  fontSize: "22px",
  fontWeight: 700,
  lineHeight: 1.2,
};
